import { render, staticRenderFns } from "./matchingList.vue?vue&type=template&id=0998b389&scoped=true"
import script from "./matchingList.vue?vue&type=script&lang=js"
export * from "./matchingList.vue?vue&type=script&lang=js"
import style0 from "./matchingList.vue?vue&type=style&index=0&id=0998b389&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0998b389",
  null
  
)

export default component.exports